import type {Demand} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';

export class DemandDataService {
    public static serviceName = 'demandDataService';

    public static readonly ROUTE = 'demands';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getDemandsByTenderId(tenderId: number, userId: number): Promise<Demand[]> {
        return this.ajaxService
            .createRequest(DemandDataService.ROUTE)
            .get({tender: tenderId, user: userId });
    }
}